import { language } from './i18n';
export * from './localstorage';
export * from './asyncPayloadCreator';

export { apiReducerBuilder } from './apiReducerBuilder';
export { downloadDocuments } from './downloadDocuments';
export { getLanguage, setCurrentLanguage, language } from './i18n';

export const isEn = language === 'en';
export const isRo = language === 'ro';
export const isLt = language === 'lt';
